var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    rx: 37.5,
    fill: "#E2D6F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8611 37.4035C36.3248 37.4035 39.1321 34.6262 39.1321 31.2011C39.1321 27.776 36.3248 25 32.8611 25C29.3974 25 26.5887 27.776 26.5887 31.2011C26.577 34.6146 29.3662 37.392 32.8169 37.4035H32.8611ZM22.6992 47.5827C22.6992 44.4223 27.5829 41.9133 32.861 41.9133C38.1677 41.9133 42.6452 44.4236 42.6452 47.5827C42.6452 50.3356 39.2226 50.291 34.8496 50.2341C34.2046 50.2257 33.5388 50.217 32.8604 50.217C32.1814 50.217 31.5099 50.2256 30.855 50.234H30.8548H30.8547C26.3909 50.2913 22.6992 50.3386 22.6992 47.5827ZM44.7051 49.8226C48.4054 49.8689 51.3014 49.9051 51.3014 47.668C51.3014 45.101 47.5127 43.0611 43.0225 43.0611C43.0225 43.0611 44.0446 45.3502 43.9419 46.8716C43.8614 48.063 43.0219 49.8087 43.0219 49.8087C43.596 49.8087 44.1593 49.8158 44.7051 49.8226ZM49.7962 33.6522C49.7962 36.3541 47.6063 38.5451 44.9044 38.5451H44.8699C42.1781 38.5359 40.0023 36.345 40.0115 33.6522C40.0115 30.9502 42.2024 28.7603 44.9044 28.7603C47.6063 28.7603 49.7962 30.9502 49.7962 33.6522Z",
    fill: "#743BBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.cdff83fd4916ebe9e8a3d6401f95d5e8.svg";
export { ForwardRef as ReactComponent };